<template>
  <layout-auth>
    <v-container class="py-10">
      <v-row>
        <v-col cols="12">
          <h1 class="text-h4 font-weight-light py-5">
            {{ $t("invoices.simulacionLiquidacion") }}
          </h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h3 class="source-sans-pro-ligh">
            {{ $t("invoices.datosAnticipos") }}
          </h3>

          <p class="source-sans-pro-regu">
            {{ $t("invoices.DetallesSimulacion") }}
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h3 class="beneficiario">
            {{ $t("invoices.nombrePagador") }}
          </h3>

          <p class="maria-laura-rivas-pa">
            {{ $t("invoices.apoderadoPrueba") }}
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="8">
          <h3 class="source-sans-pro-ligh">
            {{ $t("invoices.detallesFacturas") }}
          </h3>
        </v-col>
        <v-col cols="2">
          <h1 class="fecha-valor"> {{ $t("invoices.fechaValor") }}</h1>
        </v-col>
        <v-col cols="2">
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :rules="[rules.required]"
                readonly
                outlined
                dense
                placeholder="DD / MM / YYYY"
                v-model="computedDateFormatted"
                :color="entityConfig.primaryColor"
                persistent-hint
                append-icon="mdi-calendar"
                v-bind="attrs"
                @blur="date = parseDate(date)"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              :locale="$i18n.locale"
              :color="entityConfig.primaryColor"
              v-model="date"
              no-title
              @input="menu1 = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
       <v-container>
      <v-data-table
        no-data-text="No hay datos que mostrar"
        :headers="headers"
        :items="simulacionLiquidacion"
        class="elevation-1"
        hide-default-footer
      >
      </v-data-table>
       </v-container>
      <v-row>
        <v-col cols="9"> </v-col>
        <v-col cols="">
          <v-container>
            <h3 class="beneficiario py-5">
               {{ $t("invoices.totalLIquidadacionFina") }}  <strong>13,76</strong>
            </h3>
          </v-container>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-row>
            <h1 class="resumen">
              {{ $t("invoices.Resumen") }}
            </h1>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-10" cols="3">
          <v-row>
            <label class="labels-liquidacion"> {{ $t("invoices.cuentaAbono") }}</label>
          </v-row>
          <v-row>
            <label class="-labels-liquidacion-data">ES36 2028 4343 1976 </label>
          </v-row>
        </v-col>
        <v-col class="py-10" cols="3">
          <v-row>
            <label class="labels-liquidacion">{{ $t("invoices.fechaSolicitud") }} </label>
          </v-row>
          <v-row>
            <label class="-labels-liquidacion-data">01 May 2021 </label>
          </v-row>
        </v-col>
        <v-col class="py-10" cols="3">
          <v-row>
            <label class="labels-liquidacion">{{ $t("invoices.numerofacturasAnticipar") }}</label>
          </v-row>
          <v-row>
            <label class="-labels-liquidacion-data">3</label>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="py-10" cols="3">
          <v-row>
            <label class="labels-liquidacion">{{ $t("invoices.importeTotalFinnciar") }} </label>
          </v-row>
          <v-row>
            <label class="-labels-liquidacion-data">6.000 </label>
          </v-row>
        </v-col>
        <v-col class="py-10" cols="3">
          <v-row>
            <label class="labels-liquidacion">{{ $t("invoices.TotalLiquidación") }} </label>
          </v-row>
          <v-row>
            <label class="-labels-liquidacion-data">13,76 </label>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="12" lg="12">
          <v-btn
            outlined
            @click="volver"
            :color="entityConfig.primaryColor"
            class="float-end m-2 v-btn-width-default"
          >
            {{ $t("supplierData.goBack") }}
          </v-btn>
          <v-btn plain :color="entityConfig.primaryColor" class="float-end m-2 ">
            <v-icon left> mdi-printer-outline </v-icon>
            {{ $t("supplierData.print") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </layout-auth>
</template>

<script>
import LayoutAuth from "../../components/layouts/layout-auth.vue";

export default {
  components: {
    "layout-auth": LayoutAuth,
  },
  data: (vm) => ({
    spinner: false,
    date: "",
    dateFormatted: vm.formatDate(
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
    ),
    menu1: false,
    headers: [
      {
        text: "Nº DE FACTURA",
        sortable: false,
        value: "1",
      },
      {
        text: "IMP. A FINANCIAR",
        sortable: false,
        value: "2",
      },

      {
        text: "% INTERÉS",
        sortable: false,
        value: "3",
      },
      {
        text: "DÍAS INTERESES",
        sortable: false,
        value: "4",
      },
      {
        text: "INTERÉS",
        sortable: false,
        value: "5",
      },
      {
        text: "COMISIÓN",
        sortable: false,
        value: "5",
      },
      {
        text: "IMPUESTOS",
        sortable: false,
        value: "7",
      },
      {
        text: "GASTOS",
        sortable: false,
        value: "8",
      },
      {
        text: "IMP. COB. GTOS",
        sortable: false,
        value: "9",
      },
      {
        text: "TOTAL LIQ.",
        sortable: false,
        value: "10",
      },
    ],
    simulacionLiquidacion: [
      {
        1: "J5120000001",
        2: "2.000,00 €",
        3: "25,00",
        4: "34",
        5: "2,20",
        6: "0,04 €",
        7: "0,02",
        8: "2,00 ",
        9: "0,42",
        10: "3,44",
      },
      {
        1: "J5120000002",
        2: "2.000,00 €",
        3: "25,00",
        4: "34",
        5: "2,20",
        6: "0,04 €",
        7: "0,02",
        8: "2,00 ",
        9: "0,42",
        10: "3,44",
      },
      {
        1: "J5120000003",
        2: "2.000,00 €",
        3: "25,00",
        4: "34",
        5: "2,20",
        6: "0,04 €",
        7: "0,02",
        8: "2,00 ",
        9: "0,42",
        10: "3,44",
      },
    ],

    rules: {
      required: (value) => !!value || "Este campo es requerido..",
    },
  }),

  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },

  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
  },

  methods: {
    volver() {
      this.$router.push("/anticipo-facturas");
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${day}-${month}-${year}`;
    },
  },
};
</script>
